module.exports = __webpack_public_path__ + "img/banner.1725a12.webp";